export default "__VITE_ASSET__cvtJf0XF__"